import { OperacaoFormularioCRUD } from "service/restricao/OperacaoFormulario/OperacaoFormulario";
import { RootState } from "store/store"
import { EstadoRequisicao } from "store/types";


class SolicitacaoCorrenteFormularioSelector {
  static readonly isCarregando = (it: RootState) => it.solicitacaoCorrente.estado === EstadoRequisicao.CARREGANDO;
  static readonly operacao = (it: RootState) => it.solicitacaoCorrente.operacao;
  static readonly acao = (it: RootState) => it.solicitacaoCorrente.acao;
  static readonly erros = (it: RootState) => it.solicitacaoCorrente.erros;
  static readonly hasErros = (it: RootState) => it.solicitacaoCorrente.erros !== undefined;

  static readonly isVisualizar = (it: RootState) => SolicitacaoCorrenteFormularioSelector.operacao(it) === OperacaoFormularioCRUD.Visualizar;
}


class SolicitacaoCorrenteAnexosSelector {
  static readonly all = (it: RootState) => it.solicitacaoCorrente.anexos.elementos;
  static readonly estado = (it: RootState) => it.solicitacaoCorrente.anexos.estado;
}

export class SolicitacaoCorrenteSelector {
  static readonly solicitacao = (it: RootState) => it.solicitacaoCorrente.solicitacao;

  static readonly formulario = SolicitacaoCorrenteFormularioSelector;
  static readonly anexos = SolicitacaoCorrenteAnexosSelector;
}
